// extracted by mini-css-extract-plugin
export default {"root":"NotFound-module_root-IKyRj"};